import { render, staticRenderFns } from "./PagePagination.vue?vue&type=template&id=708eb555&scoped=true"
import script from "./PagePagination.vue?vue&type=script&lang=js"
export * from "./PagePagination.vue?vue&type=script&lang=js"
import style0 from "./PagePagination.vue?vue&type=style&index=0&id=708eb555&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708eb555",
  null
  
)

export default component.exports